import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
    public tokenInput: HTMLElement | null = null;
    private readonly document: Document;

    constructor() {
        this.document = window.document;
        this.tokenInput = this.document.getElementById('_post_token');

        if (!this.tokenInput) {
            console.warn('Element mit ID "_post_token" wurde im Konstruktor nicht gefunden.');
        }
    }
}
